export const NAME = 'manage-buildings-v2';

export const EDIT_PERMISSION = 'floor-plan-update';

// Columns that only render under a program or flag gate (see useBuildingGates).
export const GATED_COLUMN_IDS = [
  'XMLSiteName',
  'PHBuildingNumber',
  'PHBuildingEntrance',
  'RDSiteId',
  'minimumSetAside',
  'applicableFractionUnit',
  'applicableFractionFloorSpace',
  'heraSpecial',
  'fundingType',
  'certificateOfOccupancyDate',
  'constructionType',
];

export const ALPHANUMERIC_PATTERN = /^[a-zA-Z0-9]*$/;

// Mirrors ManageBuildings/BuildingsTable/Row.js until the V1 screen is removed.
export const FUNDING_TYPE_OPTIONS = [
  {
    value: '9_PERCENT_ALLOCATED_FEDERAL_HOUSING_TAX_CREDIT',
    text: '9% Allocated Federal Housing Tax Credit',
  },
  {
    value: '4_PERCENT_ALLOCATED_FEDERAL_HOUSING_TAX_CREDIT',
    text: '4% Allocated Federal Housing Tax Credit',
  },
  {
    value: 'TAX_EXEMPT_BOND_ONLY',
    text: 'Tax-Exempt Bond Only (No Tax Credits)',
  },
];

export const SET_ASIDE_OPTIONS = [
  { value: '20-50', text: '20-50' },
  { value: '40-60', text: '40-60' },
  { value: 'Average Income', text: 'Average Income' },
];

export const NYC_SET_ASIDE_OPTION = {
  value: '25-60',
  text: '25-60 (N.Y.C. Only)',
};

// FES-1531: the PATCH validator rejects unknown keys, so the payload is built from this list only.
export const EDIT_PAYLOAD_KEYS = [
  'streetAddress1',
  'city',
  'state',
  'zipCode',
  'buildingIDNumber',
  'placedInServiceDate',
  'XMLSiteName',
  'heraSpecial',
  'RDSiteId',
  'minimumSetAside',
  'PHBuildingNumber',
  'PHBuildingEntrance',
  'fundingType',
  'applicableFractionUnit',
  'applicableFractionFloorSpace',
  'certificateOfOccupancyDate',
  'constructionType',
];

export const PROPERTY_PATH_MAP = {
  name: { path: 'name', dataType: 'string' },
  buildingAddress: { path: 'buildingAddress', dataType: 'string' },
  unitsCount: { path: 'unitsCount', dataType: 'number' },
  XMLSiteName: { path: 'XMLSiteName', dataType: 'string' },
  placedInServiceDate: { path: 'placedInServiceDate', dataType: 'date' },
  buildingIDNumber: { path: 'buildingIDNumber', dataType: 'string' },
  PHBuildingNumber: { path: 'PHBuildingNumber', dataType: 'string' },
  PHBuildingEntrance: { path: 'PHBuildingEntrance', dataType: 'string' },
  RDSiteId: { path: 'RDSiteId', dataType: 'string' },
  minimumSetAside: { path: 'minimumSetAside', dataType: 'string' },
  applicableFractionUnit: {
    path: 'applicableFractionUnit',
    dataType: 'number',
  },
  applicableFractionFloorSpace: {
    path: 'applicableFractionFloorSpace',
    dataType: 'number',
  },
  heraSpecial: { path: 'heraSpecialLabel', dataType: 'string' },
  fundingType: { path: 'fundingTypeLabel', dataType: 'string' },
  certificateOfOccupancyDate: {
    path: 'certificateOfOccupancyDate',
    dataType: 'date',
  },
  constructionType: { path: 'constructionTypeLabel', dataType: 'string' },
};
